import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef } from "react";

const ConfirmBox = ({
  open,
  title,
  subTitle,
  subTitleColor,
  successText,
  rejectText,
  onSuccess,
  onReject,
}) => {
  const noButtonRef = useRef(null);


  useEffect(() => {
    if (open) {
      setTimeout(() => {
        noButtonRef.current?.focus();
      }, 0);
    }
  }, [open]);

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => {}}>
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black bg-opacity-30" />

        {/* Modal */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-md rounded bg-gray-750 p-4 shadow-xl">
            <Dialog.Title className="text-base font-medium text-white">
              {title}
            </Dialog.Title>

            <p
              className="mt-2 text-sm"
              style={{ color: subTitleColor || "#9FA0A7" }}
            >
              {subTitle}
            </p>

            {/* Actions */}
            <div className="mt-6 flex justify-end">
              {/* NO (default focused) */}
              <button
                ref={noButtonRef}
                type="button"
                onClick={onReject}
                className="
                  mr-2 rounded px-4 py-1.5 text-sm font-medium text-white
                  hover:bg-gray-700
                  focus:outline-none
                  focus:ring-2 focus:ring-white
                "
              >
                {rejectText}
              </button>

              {/* YES */}
              <button
                type="button"
                onClick={onSuccess}
                className="
                  rounded px-4 py-1.5 text-sm font-medium text-white
                  hover:bg-gray-700
                  focus:outline-none
                  focus:ring-2 focus:ring-white
                "
              >
                {successText}
              </button>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ConfirmBox;
